import type { InstallationFinanceState, InstallationFinanceStatus } from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  payment: InstallationFinanceState
  setFinanceStatus: (status: InstallationFinanceStatus) => void
  updatePayment: (patch: Partial<InstallationFinanceState>) => void
}

const InstallationFinanceSection: React.FC<Props> = ({
  isView,
  payment,
  setFinanceStatus,
  updatePayment,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>ด้านการเงิน</div>
        </div>
        <div className='card-body'>
          <p className='text-gray-700 mb-4'>การชำระเงินค่าเสา/ตอก</p>
          <div className='d-flex flex-column gap-4'>
            <div className={wonFormCheckRow}>
              <input
                className={wonFormCheckInput}
                type='radio'
                name='won-install-finance'
                id='won-install-finance-completed'
                checked={payment.status === 'completed'}
                disabled={isView}
                onChange={() => setFinanceStatus('completed')}
              />
              <label
                className={wonFormCheckLabel}
                htmlFor='won-install-finance-completed'>
                เรียบร้อย
              </label>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-finance'
                  id='won-install-finance-deposit'
                  checked={payment.status === 'deposit'}
                  disabled={isView}
                  onChange={() => setFinanceStatus('deposit')}
                />
                <label
                  className={wonFormCheckLabel}
                  htmlFor='won-install-finance-deposit'>
                  รับมัดจำ
                </label>
              </div>
              <input
                type='text'
                inputMode='decimal'
                className='form-control form-control-sm text-end'
                style={{ width: 72 }}
                value={payment.depositPercent}
                disabled={isView || payment.status !== 'deposit'}
                onChange={e => updatePayment({ depositPercent: e.target.value })}
              />
              <span className='align-self-center'>%</span>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-finance'
                  id='won-install-finance-pile-queue'
                  checked={payment.status === 'pileQueue'}
                  disabled={isView}
                  onChange={() => setFinanceStatus('pileQueue')}
                />
                <label
                  className={wonFormCheckLabel}
                  htmlFor='won-install-finance-pile-queue'>
                  คิวค่าเสา
                </label>
              </div>
              <input
                type='text'
                inputMode='numeric'
                className='form-control form-control-sm'
                style={{ width: 88 }}
                value={payment.pileQueueDays}
                disabled={isView || payment.status !== 'pileQueue'}
                onChange={e => updatePayment({ pileQueueDays: e.target.value })}
              />
              <span className='align-self-center'>วัน</span>
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-finance'
                  id='won-install-finance-driving'
                  checked={payment.status === 'drivingTicket'}
                  disabled={isView}
                  onChange={() => setFinanceStatus('drivingTicket')}
                />
                <label
                  className={wonFormCheckLabel}
                  htmlFor='won-install-finance-driving'>
                  ตั๋วค่าตอก
                </label>
              </div>
              <input
                type='text'
                inputMode='numeric'
                className='form-control form-control-sm'
                style={{ width: 88 }}
                value={payment.drivingTicketDays}
                disabled={isView || payment.status !== 'drivingTicket'}
                onChange={e => updatePayment({ drivingTicketDays: e.target.value })}
              />
              <span className='align-self-center'>วัน</span>
            </div>

            <div>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-finance'
                  id='won-install-finance-not-completed'
                  checked={payment.status === 'not_completed'}
                  disabled={isView}
                  onChange={() => setFinanceStatus('not_completed')}
                />
                <label
                  className={wonFormCheckLabel}
                  htmlFor='won-install-finance-not-completed'>
                  ไม่เรียบร้อยเนื่องจาก
                </label>
              </div>
              <textarea
                className='form-control form-control-sm mt-2'
                rows={3}
                value={payment.notCompletedReason}
                disabled={isView || payment.status !== 'not_completed'}
                onChange={e => updatePayment({ notCompletedReason: e.target.value })}
              />
            </div>

            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-finance'
                  id='won-install-finance-cheque'
                  checked={payment.status === 'cheque'}
                  disabled={isView}
                  onChange={() => setFinanceStatus('cheque')}
                />
                <label
                  className={wonFormCheckLabel}
                  htmlFor='won-install-finance-cheque'>
                  เช็ค
                </label>
              </div>
              <input
                type='text'
                className='form-control form-control-sm flex-grow-1'
                style={{ maxWidth: 280 }}
                value={payment.chequeDetail}
                disabled={isView || payment.status !== 'cheque'}
                onChange={e => updatePayment({ chequeDetail: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationFinanceSection
